package io.horion.auth.domain.usecase

import io.horion.auth.api.models.domain.profile.User
import io.horion.auth.api.models.response.Response
import io.horion.auth.api.repository.ProfileRepository
import org.koin.core.component.KoinComponent

class ProfileUseCase(
    private val profileRepository: ProfileRepository
): KoinComponent {

    suspend fun saveUser(firstName: String, lastName: String, avatar: String) : Response {
        val validationError = validateProfileInputs(firstName, lastName)
        if (validationError != null) {
            return Response(success = false, message = validationError)
        }

        return profileRepository.saveUser(
            firstName = firstName.trim(),
            lastName = lastName.trim(),
            avatar = avatar.trim(),
        )
    }

    suspend fun updateUser(firstName: String, lastName: String, avatar: String) : Response {
        val validationError = validateProfileInputs(firstName, lastName)
        if (validationError != null) {
            return Response(success = false, message = validationError)
        }

        return profileRepository.updateUser(
            firstName = firstName.trim(),
            lastName = lastName.trim(),
            avatar = avatar.trim(),
        )
    }

    suspend fun readUser() : User? {
        return profileRepository.readUser()
    }

    private fun validateProfileInputs(firstName: String, lastName: String): String? {
        val trimmedFirstName = firstName.trim()
        val trimmedLastName = lastName.trim()

        return when {
            trimmedFirstName.isEmpty() -> "Le prénom ne peut pas être vide."
            trimmedFirstName.length < 2 -> "Le prénom doit contenir au moins 2 caractères."
            trimmedFirstName.length > 50 -> "Le prénom ne peut pas dépasser 50 caractères."

            trimmedLastName.isEmpty() -> "Le nom ne peut pas être vide."
            trimmedLastName.length < 2 -> "Le nom doit contenir au moins 2 caractères."
            trimmedLastName.length > 50 -> "Le nom ne peut pas dépasser 50 caractères."

            else -> null
        }
    }

}